module.exports = __webpack_public_path__ + "static/TiemposText-Semibold-fbd43de797345958ad5e575f9d49869d.ttf";